module.exports = __webpack_public_path__ + "img/gdq_hero.b1b6035c.jpg";